"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * @author Adam Drda
 */


var ReleaseImpactDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ReleaseImpactDTO, _DomainObject_1$Domai);

  /**
   * @param releaseId internal id of release
   * @param daysDiff days of release being valid in given week
   * @param profitDiff diff between total real profit and total expected profit after repricing
   * @param revenueDiff diff between total real revenue and total expected revenue after repricing
   * @param salesVolumeDiff diff between total real sales volume and total expected sales volume after repricing
   * @param marginDiff diff between total real BM2 and total expected BM2 after repricing
   */
  function ReleaseImpactDTO(releaseId, daysDiff, profitDiff, revenueDiff, salesVolumeDiff, marginDiff) {
    var _this;

    _classCallCheck(this, ReleaseImpactDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReleaseImpactDTO).call(this));
    _this.releaseId = releaseId;
    _this.daysDiff = daysDiff;
    _this.profitDiff = profitDiff;
    _this.revenueDiff = revenueDiff;
    _this.salesVolumeDiff = salesVolumeDiff;
    _this.marginDiff = marginDiff;
    return _this;
  }

  return ReleaseImpactDTO;
}(DomainObject_1.DomainObject);

exports.ReleaseImpactDTO = ReleaseImpactDTO;

ReleaseImpactDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ReleaseImpactDTO.name);
  return {
    releaseId: builder.str('releaseId'),
    daysDiff: builder.opt(builder.num('daysDiff')),
    profitDiff: builder.opt(builder.bigNum('profitDiff')),
    revenueDiff: builder.opt(builder.bigNum('revenueDiff')),
    salesVolumeDiff: builder.opt(builder.bigNum('salesVolumeDiff')),
    marginDiff: builder.opt(builder.bigNum('marginDiff'))
  };
}();